import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, forwardRef } from 'react';
import classnames from 'classnames';
import useConfig from '../../hooks/useConfig';
var cls = 'tabs-title';
var TabsTitle = /*#__PURE__*/forwardRef(function (props, ref) {
  var isActive = props.isActive,
    activeColor = props.activeColor,
    inactiveColor = props.inactiveColor,
    className = props.className,
    style = props.style;
  var _useConfig = useConfig(),
    createNamespace = _useConfig.createNamespace,
    prefixCls = _useConfig.prefixCls;
  var classes = classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls, prefixCls), className, {
    active: props.isActive
  });
  var customStyle = useMemo(function () {
    var styles = Object.assign({}, style);
    var titleColor = isActive ? activeColor : inactiveColor;
    if (titleColor) {
      styles.color = titleColor;
    }
    return styles;
  }, [isActive, activeColor, inactiveColor, style]);
  var renderText = function renderText() {
    var Title = _jsx("span", Object.assign({
      className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-text", prefixCls))
    }, {
      children: function () {
        if (typeof props.title === 'function') {
          return props.title(isActive);
        }
        return props.title;
      }()
    }));
    return Title;
  };
  return _jsx("div", Object.assign({
    ref: ref,
    className: classes,
    style: customStyle,
    "aria-selected": props.isActive,
    onClick: props.onClick
  }, {
    children: renderText()
  }));
});
TabsTitle.displayName = 'TabsTitle';
export default TabsTitle;